<template>
    <div class="content">
        <div class="list">
            <van-list 
                v-model="loading" 	                     		 
                :finished="finished" 							 
                finished-text="没有更多数据了"						 
                @load="onLoad" 									
                offset="50"									 
                :error.sync="error" 							 
                error-text="请求失败，点击重新加载"					 
                >
                <div class="content-item"  v-for="item in list" :key="item.id" @click="goDetail(item)">
                        <div class="video"><img :src="item.imageInputs" alt=""></div>
                        <div class="title line1">{{item.title}}</div>
                    <!-- <video width="100%" v-if="item.spUrl" controls="controls">
                        <source :src="item.spUrl" type="video/mp4" />
                    </video> -->

                </div>
            </van-list>  
        </div>
    </div>
</template>

<script>
export default {
  
  data(){
    return{
      loading: false, 		// 是否处在加载状态
      finished: false, 		// 是否已加载完成
      error: false, 		// 是否加载失败
      list: [],				// 列表
      page:1,
      limit:10,
      total: 0,			// 数据总条数
      active:0,
      classId:0,
      newVideo:[]
    }
  },
  created(){
    // this.getVideo()
     
  },
  methods:{
    getVideo(){
        this.http.get('/api/front/article/spList/3?page=1&limit=10').then((res)=>{
            if(res.data.data.list){
                this.list = res.data.data.list
            }
          })
        },
    goDetail(item){
      sessionStorage.setItem('videoData',JSON.stringify(item))
      this.$router.push({
          path: '/videoDetail'})
    },
    changeActive(index,pid){
      this.page = 1
      this.list= []
       this.active = index
       this.classId = pid
       this.onLoad()
    },
    // 获取列表数据方法
    async getList() {
      this.http.get(`/api/front/article/spList/3?page=${this.page}&limit=${this.limit}`).then(res =>{
           if (res.data.data.list === 0) {  		// 判断获取数据条数若等于0
                this.list = [];				// 清空数组
                this.finished = true;		// 停止加载
            }
            // 若数据条数不等于0
            this.total = res.data.data.total;		// 给数据条数赋值
            this.list.push(...res.data.data.list)	// 将数据放入list中
            this.loading = false;			// 加载状态结束 
            // 如果list长度大于等于总数据条数,数据全部加载完成
            if (this.list.length >= res.data.data.total) {
                this.finished = true;		// 结束加载状态
            }
      })
    },
	// 被 @load调用的方法
    onLoad() { // 若加载条到了底部
      let timer = setTimeout(() => {	// 定时器仅针对本地数据渲染动画效果,项目中axios请求不需要定时器
        this.getList();					// 调用上面方法,请求数据
        this.page++;					// 分页数加一
        this.finished && clearTimeout(timer);//清除计时器
      }, 100);
    },
	// 加载失败调用方法
    onRefresh() {
      this.finished = false; 		// 清空列表数据
      this.loading = true; 			// 将 loading 设置为 true，表示处于加载状态
      this.page = 1;				// 分页数赋值为1
      this.list = [];				// 清空数组
      this.onLoad(); 				// 重新加载数据
    }
  }
}
</script>

<style lang="less" scoped>
.content{
   .list{
     padding: 0 .1rem;
    //  padding-top:2.2rem;
     padding-top:1rem;
      .van-list{
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        .content-item{
            width: calc(50% - 0.2rem);
            margin: 0.1rem;
            border-radius:0.1rem;
            display: flex;
            flex-direction: column;
           .video{
            width: 100%;
            height: 4.5rem;
            background: #000;
            display: flex;
            justify-content: center;
            align-items: center;
            border-top-left-radius:0.1rem;
            border-top-right-radius:0.1rem;
            img{
              max-width: 100%;
              max-height: 100%;
              border-radius:0.1rem;
              display: inline-block;
              margin: auto;
            }
           }
            .title{
               background: #fff;
               padding: 0.1rem 0.2rem;
               line-height: 0.36rem;
               border-bottom-left-radius:0.1rem;
              border-bottom-right-radius:0.1rem;
            }
            .line1{
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        /deep/.van-list__finished-text{
            width: 100%;
        }
      }
   }
}
</style>


// WEBPACK FOOTER //
// src/components/vid.vue